import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Target, Factory, DollarSign } from "lucide-react";
import { formatCurrency } from "@/lib/config";

export function StatutDepotBadge({ depot }) {
  if (!depot?.existe) return <Badge variant="outline" className="text-xs bg-gray-50 text-gray-500">Pas de facture</Badge>;
  if (depot.statut === 'paye') return <Badge className="text-xs bg-green-100 text-green-700 border-green-200">Dépôt reçu</Badge>;
  if (depot.statut === 'partiel') return <Badge className="text-xs bg-amber-100 text-amber-700 border-amber-200">Partiel {formatCurrency(depot.montant_paye)}</Badge>;
  return <Badge className="text-xs bg-red-100 text-red-700 border-red-200">Dépôt en attente {formatCurrency(depot.montant)}</Badge>;
}

export function StatutDossierBadge({ statut }) {
  const map = {
    en_production: { label: "En production", color: "bg-blue-100 text-blue-700" },
    en_attente_production: { label: "Planifié", color: "bg-purple-100 text-purple-700" },
    accepte: { label: "Accepté", color: "bg-emerald-100 text-emerald-700" },
    finalise: { label: "Finalisé", color: "bg-gray-100 text-gray-700" },
  };
  const s = map[statut] || { label: statut, color: "bg-gray-100 text-gray-600" };
  return <Badge className={`text-xs ${s.color} border-0`}>{s.label}</Badge>;
}

export function ProgressSection({ title, icon: Icon, color, items, tooltip }) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <Icon className={`w-4 h-4 ${color}`} />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 pt-0">
        {items.map(({ label, reel, objectif, couleur }) => {
          const pct = objectif > 0 ? (reel / objectif) * 100 : 0;
          const barPct = Math.min(100, pct);
          const barColor = pct >= 100 ? "#059669" : pct >= 75 ? "#d97706" : pct >= 50 ? "#f59e0b" : "#dc2626";
          return (
            <div key={label}>
              <div className="flex justify-between text-xs mb-0.5">
                <span className="font-medium text-slate-700">{label}</span>
                <span className="text-slate-500">{formatCurrency(reel)} / {objectif > 0 ? formatCurrency(objectif) : "—"}</span>
              </div>
              {objectif > 0 ? (
                <div className="flex items-center gap-2">
                  <div className="flex-1 bg-gray-100 rounded-full h-2">
                    <div className="h-2 rounded-full transition-all" style={{ width: `${barPct}%`, backgroundColor: barColor }} />
                  </div>
                  <span className="text-xs font-semibold w-12 text-right" style={{ color: barColor }}>{pct.toFixed(0)}%</span>
                </div>
              ) : (
                <p className="text-xs text-amber-600">Aucun objectif configuré</p>
              )}
            </div>
          );
        })}
        {tooltip && <p className="text-xs text-slate-400 mt-1">{tooltip}</p>}
      </CardContent>
    </Card>
  );
}
